export const SendOtpErrorMessages = {
    EMAIL_NOT_FOUND: 'This email id does not exist',
    INVALID_EMAIL: 'Please enter a valid email id',
};
export const SignInWithOtpErrorMessages = {
    INCORRECT_OTP: 'Uh-oh! Incorrect OTP entered.',
};
export const SOMETHING_WENT_WRONG = 'Something went wrong';
